import config from 'config'

let bootstrapPromise = null
const libraryPromises = new Map()

const resetBootstrap = () => {
  bootstrapPromise = null
  libraryPromises.clear()

  const script = document.querySelector('script[data-google-maps-bootstrap="true"]')
  if (script) script.remove()

  if (window.google?.maps) {
    delete window.google.maps.importLibrary
  }
}

const ensureImportLibrary = () => {
  if (window.google?.maps?.importLibrary) {
    return Promise.resolve()
  }

  if (bootstrapPromise) return bootstrapPromise

  bootstrapPromise = new Promise((resolve, reject) => {
    const googleNamespace = (window.google = window.google || {})
    const mapsNamespace = (googleNamespace.maps = googleNamespace.maps || {})

    if (mapsNamespace.importLibrary) {
      resolve()
      return
    }

    const requestedLibraries = new Set()
    const params = new URLSearchParams()
    const callbackName = '__ib__'

    const appendScript = () => {
      const script = document.createElement('script')

      params.set('key', config.google.MAPS)
      params.set('v', 'weekly')
      params.set('loading', 'async')
      params.set('libraries', [...requestedLibraries].join(','))
      params.set('callback', `google.maps.${callbackName}`)

      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`
      script.async = true
      script.onerror = () => {
        resetBootstrap()
        reject(new Error('Google Maps JavaScript API could not load.'))
      }

      const nonceScript = document.querySelector('script[nonce]')
      if (nonceScript?.nonce) script.nonce = nonceScript.nonce

      mapsNamespace[callbackName] = () => resolve()
      document.head.appendChild(script)
    }

    mapsNamespace.importLibrary = (libraryName, ...args) => {
      requestedLibraries.add(libraryName)

      if (!document.querySelector('script[data-google-maps-bootstrap="true"]')) {
        appendScript()
        const bootstrapScript = document.head.lastElementChild
        if (bootstrapScript) {
          bootstrapScript.setAttribute('data-google-maps-bootstrap', 'true')
        }
      }

      return bootstrapPromise.then(() => mapsNamespace.importLibrary(libraryName, ...args))
    }
  })

  return bootstrapPromise
}

const ensureLibrary = (libraryName) => {
  if (!libraryPromises.has(libraryName)) {
    ensureImportLibrary()
    libraryPromises.set(libraryName, window.google.maps.importLibrary(libraryName))
  }

  return libraryPromises.get(libraryName)
}

export const loadGoogleMapsLibraries = async (libraries = []) => {
  const uniqueLibraries = [...new Set(libraries)]
  await Promise.all(uniqueLibraries.map(ensureLibrary))

  return window.google
}
